"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M3 7.5A2.5 2.5 0 0 1 5.5 5h13A2.5 2.5 0 0 1 21 7.5V8H7.5a.5.5 0 0 0 0 1H21v1.5h-4.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1H21a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M16.5 12.5v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1m2.5 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
  })]
}), 'WalletFilled');
